<template>
<v-card class="crud-dialog">
  <v-card-title class="headline">
    <v-icon>vpn_key</v-icon> Regenerar token
    <v-btn icon @click.native="$store.commit('closeModal', 4)">
      <v-icon>close</v-icon>
    </v-btn>
  </v-card-title>
  <v-card-text>
    <h5><strong>Trámite: </strong>{{ doc.documento.nombre }}</h5>
    <v-alert
      color="info"
      icon="info"
      :value="true">
      Se regenerará el Token del trámite para que pueda realizar pagos en la <strong>Plataforma de pagos</strong>.
    </v-alert>
    <div v-if="showUsuariosApp">
      <v-alert
        color="info"
        icon="info"
        v-if="doc.usuariosApp.length > 1"
        :value="true">
        Seleccione una Aplicación que esté asociada al trámite que quiere crear, de la misma forma en que lo hace en la Plataforma de Pagos
      </v-alert>
      <v-select
        :items="doc.usuariosApp"
        v-model="usuarioapp"
        label="Aplicación en la Plataforma de pago"
        item-text="endpoint"
        item-value="id_usuario_app"
        :readonly="doc.usuariosApp.length == 1"
        autocomplete
        noDataText="No hay resultados"></v-select>
    </div>
    <v-alert
      v-if="!showUsuariosApp && documento"
      color="warning"
      icon="warning"
      :value="true">
      El documento seleccionado no tiene asociado ninguna Aplicación en la Plataforma de Pagos
    </v-alert>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn
      @click.native="$store.commit('closeModal', 4)">
      <v-icon>cancel</v-icon> Cancelar
    </v-btn>
    <v-btn
      color="primary"
      @click="obtainTokenForDocument()"
      :disabled="!show || loading">
      <v-icon>check_circle</v-icon> Regenerar token
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  props: ['doc'],
  data () {
    return {
      documento: null,
      usuarioapp: null,
      show: false,
      showUsuariosApp: false,
      idEntidadPPTE: null,
      idTramtie: null,
      loading: false
    };
  },
  created () {
    this.documento = this.doc.documento.codigo_portal;
    this.getTramite(this.documento);
  },
  methods: {
    obtainTokenForDocument () { // get number of tramites. send idEndidad e idTramite en PPTE
      this.loading = true;
      let datos = Object.assign({}, this.doc.documento);
      delete datos.id;
      this.$service.post(`eapostilla/obtener_token_tramite/${this.idEntidadPPTE}/${this.idTramite}/${this.usuarioapp.id_usuario_app ? this.usuarioapp.id_usuario_app : this.usuarioapp}`, datos)
      .then(response => {
        this.loading = false;
        if (response) {
          this.show = false;
          this.showUsuariosApp = false;
          this.idEntidadPPTE = null;
          this.idTramite = null;
          this.$store.commit('closeModal', 4);
          this.$message.success('El token se regeneró correctamente.');
          document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
        }
      });
    },
    getTramite (val) {
      if (this.obtenerCodigosPortalDeTramitesEnPpte.includes(val.toString())) { // codigo PortalTramites existe en PPTE?
        this.showUsuariosApp = true;
        this.idTramite = this.doc.datosTramitesEntidadPpte.filter(x => x.codigoPortalUnico === val.toString())[0].id;

        if (this.doc.usuariosApp && this.doc.usuariosApp.length === 1) {
          this.usuarioapp = this.doc.usuariosApp[0];
        }
        this.show = true;
      } else {
        this.showUsuariosApp = false;
        this.usuarioapp = null;
        this.show = false;
      }
    }
  },
  computed: {
    obtenerCodigosPortalDeTramitesEnPpte: function () {
      return this.doc.datosTramitesEntidadPpte.map(x => x.codigoPortalUnico);
    }
  },
  watch: {
    documento: function (val) {
      this.getTramite(val);
    },
    usuarioapp: function (val) {
      if (val) {
        this.show = true;
        if (this.doc.usuariosApp.length === 1) {
          if (val.id_entidad) {
            this.idEntidadPPTE = val.id_entidad;
          }
        } else {
          this.idEntidadPPTE = this.doc.usuariosApp.filter(x => x.id_usuario_app === val)[0].id_entidad;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// Regenerar.vue?524a83d2